
type SubModulo = {
  id: string;
  titulo: string;
  componentType: string;
  exibir: boolean;
  acao?: () => void;
  url?: string;
  ativo: boolean;
}

export function verificarExistenciaDeSubModulos(subModulos: SubModulo[]) {
  if (!Array.isArray(subModulos)) {
    return false;
  }
  return subModulos.some((subModulo) => subModulo.exibir);
}
